<template>
  <div class="columns is-gapless">
    <div class="columns column is-3">
      <div
        class="column is-paddingless-right is-8 is-padding-left-small is-paddingless-top is-padding-bottom-small">
        {{origin.name}}
      </div>
      <div
        class="column is-4 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        {{origin.contacts.length}}
      </div>
    </div>
    <div class="columns column is-6">
      <div
        class="column is-2 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        {{origin.rdvs.length}}
      </div>
      <div
        class="column is-2 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        <span v-if="contactCost">{{contactCost| prettyPrice}}</span>
        <span v-else>--</span>
        <br>
      </div>
      <div
        class="column is-2 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        <span v-if="rdvCost">{{rdvCost| prettyPrice}}</span>
        <span v-else>--</span>
      </div>
      <div
        class="column is-2 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        <span v-if="currentCost">{{currentCost.cost | prettyPrice}} {{$currency}}</span>
        <span v-else>--</span>
      </div>
      <div
        class="column is-2 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        {{origin.advs.length}}
      </div>
      <div
        class="column is-2 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        <span v-if="currentCost">{{currentCost.margin | prettyPrice}} {{$currency}}</span>
        <span v-else>--</span><br>
      </div>
    </div>
    <div class="columns column is-3 has-bg-lighter is-border-left">
      <div class="column is-4 is-paddingless-right is-paddingless-top is-padding-bottom-small is-padding-left-small">
        <span v-if="saleRatio">{{saleRatio | prettyPrice}} {{$currency}}</span>
        <span v-else>--</span><br>
      </div>
      <div
        class="column is-5 is-paddingless-right is-padding-left-small is-paddingless-top is-padding-bottom-small">
        <span v-if="margin">{{margin | prettyPrice}} {{$currency}}</span>
        <span v-else>--</span><br>
      </div>
    </div>
  </div>
</template>

<script>
  import { OriginRowMx } from '../../../mixins'
  export default {
    name: 'ChildRow',
    mixins: [OriginRowMx],
    props: {
      date: {
        type: Object,
        required: true
      },
      origin: {
        type: Object,
        required: true
      }
    },
    computed: {
      row () {
        return this.origin
      },
      rdvs () {
        return this.row.rdvs.length
      },
      contacts () {
        return this.row.contacts.length
      },
      advs () {
        return this.row.advs.length
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/statistics/multidiffusion/ChildRow.vue